<app-base-modal [id]="modalId" [title]="modalTitle | translate" [size]="modalSize" [isFixedHeight]="true">
  <ng-content></ng-content>
</app-base-modal>
